import { Component } from '@angular/core';
import { AppUtil } from '../../../utils/app.util';

/**
 * Footer Component
 */
@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
	/** Holds current year value */
	currentYear: any = AppUtil.getCurrentYear();

	/**
	 * Footer component constructor
	 */
	constructor() {}
}
